=<template>
  <CDialog
    width="640px"
    :title="$t('Select Billing Group')"
    :visible.sync="currentVisible"
    closeable
  >
    <CList>
      <div v-for="(group, i) in showingBillingGroups" :key="group.billingGroupId">
        <CItem clickable @click="$emit('chooseGroup', group.billingInternalId)">
          <CItemSection>
            <CItemLabel>{{ group.billingGroupName }}</CItemLabel>
            <CItemLabel caption>
              {{ `id: ${group.billingGroupId}` }}
            </CItemLabel>
          </CItemSection>
        </CItem>
        <CSeparator v-if="i < billingGroups.length - 1" spaced />
      </div>
    </CList>
    <q-pagination
      class="pagination"
      v-model="currentPage"
      :max="maxPages"
      direction-links
      flat
      color="grey"
      active-color="primary"
    />
  </CDialog>
</template>

<script>
import Vue from 'vue';
import CDialog from '@/components/uikit/CDialog';
import CList from '@/components/uikit/CList';
import CItem from '@/components/uikit/CItem';
import CItemSection from '@/components/uikit/CItemSection';
import CItemLabel from '@/components/uikit/CItemLabel';
import CSeparator from '@/components/uikit/CSeparator';

const messages = {
  en: {
    'Select Billing Group': 'Select Billing Group',
  },
  ja: {
    'Select Billing Group': '請求グループを選択',
  },
};

export default Vue.extend({
  components: {
    CDialog,
    CList,
    CItem,
    CItemSection,
    CItemLabel,
    CSeparator,
  },
  i18n: { messages },
  props: {
    value: {
      type: Boolean,
    },
    billingGroups: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      currentPage: 1,
    };
  },
  computed: {
    currentVisible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    groupPerPage() {
      return 3;
    },
    maxPages() {
      return Math.ceil(this.billingGroups.length / this.groupPerPage);
    },
    showingBillingGroups() {
      const start = this.groupPerPage * (this.currentPage - 1);
      const end =
        start + this.groupPerPage <= this.billingGroups.length
          ? start + this.groupPerPage
          : this.billingGroups.length;
      return this.billingGroups.slice(start, end);
    },
  },
});
</script>

<style scoped>
.pagination {
  margin-top: 16px;
  justify-content: center;
}
</style>
